import React from "react";
import Button from "@mui/material/Button";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const testFunc = (answerData, index) => {
  // const answerTest = [];
  // answerData.answer_id.map((item, idx) => {
  //   return answerTest.push({ [`ans${idx + 1}`]: item.ans1 });
  // });
  return {
    [`ans${index + 1}.1`]: answerData.ans1.join(","),
    [`ans${index + 1}.2`]: answerData.ans2.join(","),
  };
};
function createData(name, score, allAns, LessonLog) {
  const logArray = LessonLog;
  const obj = {
    name: name,
    score: score,
  };

  let ans = {};
  let timeStart = {};
  let timeEnd = {};
  let logStart = {};
  let logEnd = {};

  for (let i = 0; i < allAns.length; i++) {
    if (typeof allAns[i].answer_id === "object") {
      ans = testFunc(allAns[i].answer_id, i);
      // ans = { [`ans${i + 1}`]: allAns[i].answer_id };
    } else {
      ans = { [`ans${i + 1}`]: allAns[i].answer_id };
    }
    timeStart = { [`timeStart${i + 1}`]: allAns[i].timeStart };
    timeEnd = { [`timeEnd${i + 1}`]: allAns[i].timeEnd };
    Object.assign(obj, ans, timeStart, timeEnd);
  }
  for (let i = 0; i < logArray.length; i++) {
    logStart = { [`logStart${i + 1}`]: logArray[i].timeStart };
    logEnd = { [`logEnd${i + 1}`]: logArray[i].timeEnd };
    Object.assign(obj, logStart, logEnd);
  }
  return obj;
}

const ExportExcelContainer = ({ dataArray, selectedWeek }) => {
  const renderDataSet = (score, content) => {
    const allDataSet = [];
    for (let i = 0; i < score.length; i++) {
      const LessonLog = content.filter((item) => item.user === score[i].user);
      const test3 = createData(
        score[i].user,
        score[i].data.score,
        score[i].data.allAnswer,
        LessonLog[0].data.data
      );
      allDataSet.push(test3);
    }
    return allDataSet;
  };

  const LogStartRender = (logArray, scoreArray) => {
    if (logArray.length > 0) {
      for (let i = 0; i < scoreArray.length; i++) {
        const LessonLog = logArray.filter(
          (item) => item.user === scoreArray[i].user
        );
        return LessonLog[0].data.data.map((item2, idx) => {
          return (
            <ExcelColumn label={`LS${idx + 1}`} value={`logStart${idx + 1}`} />
          );
        });
      }
    } else {
      return <ExcelColumn label={`LS0`} value={`null`} />;
    }
  };

  const LogEndRender = (logArray, scoreArray) => {
    if (logArray.length > 0) {
      for (let i = 0; i < scoreArray.length; i++) {
        const LessonLog = logArray.filter(
          (item) => item.user === scoreArray[i].user
        );
        return LessonLog[0].data.data.map((item2, idx) => {
          return (
            <ExcelColumn label={`LE${idx + 1}`} value={`logEnd${idx + 1}`} />
          );
        });
      }
    } else {
      return <ExcelColumn label={`LE0`} value={`null`} />;
    }
  };

  const QuizStartRender = (scoreArray) => {
    if (scoreArray.length > 0) {
      for (let i = 0; i < scoreArray.length; i++) {
        const ansLog = scoreArray.filter(
          (item) => item.user === scoreArray[i].user
        );
        return ansLog[0].data.allAnswer.map((item2, idx) => {
          return (
            <ExcelColumn label={`QS${idx + 1}`} value={`timeStart${idx + 1}`} />
          );
        });
      }
    } else {
      return <ExcelColumn label={`QS0`} value={`null`} />;
    }
  };
  const QuizEndRender = (scoreArray) => {
    if (scoreArray.length > 0) {
      for (let i = 0; i < scoreArray.length; i++) {
        const ansLog = scoreArray.filter(
          (item) => item.user === scoreArray[i].user
        );
        return ansLog[0].data.allAnswer.map((item2, idx) => {
          return (
            <ExcelColumn label={`QE${idx + 1}`} value={`timeEnd${idx + 1}`} />
          );
        });
      }
    } else {
      return <ExcelColumn label={`QE0`} value={`null`} />;
    }
  };
  const renderAnswer1 = (scoreArray) => {
    if (scoreArray.length > 0) {
      for (let i = 0; i < scoreArray.length; i++) {
        const ansLog = scoreArray.filter(
          (item) => item.user === scoreArray[i].user
        );
        return ansLog[0].data.allAnswer.map((item2, idx) => {
          return (
            <ExcelColumn label={`Ans${idx + 1}`} value={`ans${idx + 1}`} />
          );
        });
      }
    } else {
      return <ExcelColumn label={`Ans0`} value={`null`} />;
    }
  };
  return (
    <ExcelFile
      element={
        <Button variant="outlined" color="success">
          ข้อมูลนักเรียนทุกชั้นปี สัปดาห์ที่ {selectedWeek}
        </Button>
      }
      filename={`stuScoreWeek${selectedWeek}`}
    >
      {dataArray.map((item, idx) => (
        <ExcelSheet
          data={renderDataSet(item.data, item.content)}
          name={`studentGrade${4 + idx}`}
        >
          <ExcelColumn label="username" value="name" />
          <ExcelColumn label="Score" value="score" />
          {renderAnswer1(item.data)}
          {QuizStartRender(item.data)}
          {QuizEndRender(item.data)}
          {/* <ExcelColumn label="QS1" value="timeStart1" />
          <ExcelColumn label="QS2" value="timeStart2" />
          <ExcelColumn label="QS3" value="timeStart3" />
          <ExcelColumn label="QS4" value="timeStart4" />
          <ExcelColumn label="QS5" value="timeStart5" /> */}
          {/* <ExcelColumn label="QE1" value="timeEnd1" />
          <ExcelColumn label="QE2" value="timeEnd2" />
          <ExcelColumn label="QE3" value="timeEnd3" />
          <ExcelColumn label="QE4" value="timeEnd4" />
          <ExcelColumn label="QE5" value="timeEnd5" /> */}
          {LogStartRender(item.content, item.data)}
          {LogEndRender(item.content, item.data)}
        </ExcelSheet>
      ))}
    </ExcelFile>
  );
};

export default ExportExcelContainer;
